<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ title | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <span class="header-close-link" (click)="close()">
                <ion-icon class="bp-close"></ion-icon>
            </span>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="content">
    <div class="container-wrapper">
        <div class="job-table">
            <table>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>{{'generic.job.description' | translate}}</th>
                        <th *ngIf="!filterByPage">{{'generic.job.page' | translate}}</th>
                        <th>{{'generic.job.status' | translate}}</th>
                        <th>{{'generic.job.progress' | translate}}</th>
                        <th>{{'generic.job.action' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let job of jobs | async; let uIndex = index">
                        <td><b>{{job?.jobId}}</b></td>
                        <td>{{job.jobName | translate}}</td>
                        <td *ngIf="!filterByPage">{{job.pageComponentName || '-'}}</td>
                        <td>{{ job.progress?.status == jobStatusEnum.Fail ? ('generic.job.failed' | translate) : job.progress?.message | translate}}</td>
                        <td>{{ job.progress.progressPercentage > 100 ? 99 : job.progress.progressPercentage }}%</td>
                        <td class="actions-column">
                            <div class="action-buttons">
                                <span *ngIf="job.progress.data && job.progress.progressPercentage >= 100 && (job.progress?.status && job.progress.status !== jobStatusEnum.Fail && job.progress.status !== jobStatusEnum.Deleted)"
                                          class="action-link"
                                      (click)="openEmailModal(job)">
                                    <ion-icon name="mail-outline"></ion-icon>
                                    {{ 'generic.sendEmail' | translate }}
                                </span>
                                <span *ngIf="job.progress?.status !== jobStatusEnum.Fail && job.progress?.status !== jobStatusEnum.Deleted"
                                      class="action-link"
                                      [class.disabled]="!job.progress.data || job.progress.progressPercentage < 100"
                                      (click)="job.progress.data && job.progress.progressPercentage >= 100 ? goToUrl(job.progress.data) : null">
                                    <ion-icon name="download-outline"></ion-icon>
                                    {{ 'feedback.popup.download' | translate }}
                                </span>
                                <span *ngIf="(!job.progress.data && job.progress.progressPercentage == 100) || job.progress?.status === jobStatusEnum.Fail || job.progress?.status === jobStatusEnum.Deleted"
                                      class="action-link danger"
                                      (click)="confirmDeleteJob(job)">
                                    <ion-icon name="trash-outline"></ion-icon>
                                    {{ 'generic.exclude' | translate }}
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="divider"></div>
    <ion-footer class="footer-buttons">
        <ion-toolbar>
            <div class="button-container">
                <ion-button fill="outline" color="primary" (click)="close()">
                    {{ 'generic.close' | translate }}
                </ion-button>
            </div>
        </ion-toolbar>
    </ion-footer>
</ion-content>
